/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B000150 得意先照会
 */
import { Column, Query } from "@material-table/core";
import {
  B000111TokuibunNm,
  B000150Find,
  B000150FindRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import { getClientError } from "messages";
import { B000ShokaKbn, getSCode, SCode, Torihikisakibun } from "messages/codes";
import { labels } from "messages/labels";
import { B000111 } from "pages";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { mapIds } from "services";
import { focusState, SDialogContext, useFocus } from "states";

// TODO: エラーの文章未確定

// 呼び出し時のプロパティ
type Props = Partial<{
  // 得意先(0orなし)・請求先区分(1)・売掛先(2)・全件(3)の検索条件設定項目
  calledParam: string;
  // 削除予定区分チェック除外区分(1の場合、削除予定区分を無視)
  deljogaiKbn: string;
  // 取引終了日付
  torihikishuryoYmd: string;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  shokaKbn: SCode;
  name: string;
  torihikisakibun: SCode;
  tokuibunCd: string;
  calledParam: string;
  deljogaiKbn: string;
  torihikishuryoYmd: string;
}>;

// テーブル定義
type Data = Partial<{
  gyoNo: number;
  tokuiCd: string;
  tokuiShitenCd: string;
  tokuiNm1: string;
  tokuiNm2: string;
  tokuiKana: string;
  shainCd: string;
  tokuiKbn: number;
  tokuiNmr: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokuchiKbn: number;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  seikyuKbn: number;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: number;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: number;
  urikakeshainCd: string;
  tankaKakeritsu: number;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
  zeiKbn: string;
  zeimarumeKbn: number;
  zeihasuichi: number;
  kinmarumeKbn: number;
  kinhasuichi: number;
  shokaKbn: number;
  denpyoshubetsuCd: string;
  denpyogyosu: number;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shutsuryokushohinCd: number;
  jodaihyojiKbn: number;
  unsogaishaCd: string;
  shimeD: number;
  kaishuyoteiM: number;
  kaishuyoteiD: number;
  seikyushoKbn: number;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: number;
  seikyushoNo: number;
  kaishuKbn: number;
  itakusokoCd: string;
  shatenCd: string;
  kigyoCd: string;
  tenpoCd: string;
  tankamarumeKbn: number;
  tankahasuichi: number;
  kyakusakinoKbn: number;
  sakujoyoteiKbn: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiCdTo: "",
  tokuishitenCdTo: "",
  shokaKbn: getSCode(B000ShokaKbn, "0"),
  name: "",
  torihikisakibun: null,
  tokuibunCd: "",
  calledParam: "",
  deljogaiKbn: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "2rem", align: "right" },
  { field: "tokuiCd", title: "得意先コード", width: "4rem" },
  { field: "tokuishitenCd", title: "　", width: "3rem" },
  { field: "tokuiNm1", title: "得意先名", width: "13rem" },
  { field: "tokuiNm2", title: "　", width: "8rem" },
  { field: "tokuiKana", title: "得意先カナ", width: "7rem" },
  { field: "shainCd", hidden: true },
  { field: "tokuiKbn", hidden: true },
  { field: "tokuiNmr", hidden: true },
  { field: "postCd", hidden: true },
  { field: "address1", hidden: true },
  { field: "address2", hidden: true },
  { field: "telNo", hidden: true },
  { field: "faxNo", hidden: true },
  { field: "shokuchiKbn", hidden: true },
  { field: "torihikikaishiYmd", hidden: true },
  { field: "torihikishuryoYmd", hidden: true },
  { field: "seikyuKbn", hidden: true },
  { field: "seikyuCd", hidden: true },
  { field: "seikyushitenCd", hidden: true },
  { field: "urikakeKbn", hidden: true },
  { field: "urikakeCd", hidden: true },
  { field: "urikakeshitenCd", hidden: true },
  { field: "nonyuKbn", hidden: true },
  { field: "urikakeshainCd", hidden: true },
  { field: "tankaKakeritsu", hidden: true },
  { field: "tokuibunCd1", hidden: true },
  { field: "tokuibunCd2", hidden: true },
  { field: "tokuibunCd3", hidden: true },
  { field: "tokuibunCd4", hidden: true },
  { field: "tokuibunCd5", hidden: true },
  { field: "zeiKbn", hidden: true },
  { field: "zeimarumeKbn", hidden: true },
  { field: "zeihasuichi", hidden: true },
  { field: "kinmarumeKbn", hidden: true },
  { field: "kinhasuichi", hidden: true },
  { field: "shokaKbn", hidden: true },
  { field: "denpyogyosu", hidden: true },
  { field: "denpyoshubetsuCd", hidden: true },
  { field: "denpyoKbn", hidden: true },
  { field: "tenpudenpyoCd", hidden: true },
  { field: "ritsu", hidden: true },
  { field: "bunrui", hidden: true },
  { field: "torihikisakiCd", hidden: true },
  { field: "hyakatenCd", hidden: true },
  { field: "shutsuryokushohinCd", hidden: true },
  { field: "jodaihyojiKbn", hidden: true },
  { field: "unsogaishaCd", hidden: true },
  { field: "shimeD", hidden: true },
  { field: "kaishuyoteiM", hidden: true },
  { field: "kaishuyoteiD", hidden: true },
  { field: "seikyushoKbn", hidden: true },
  { field: "seikyushokeishikiKbn", hidden: true },
  { field: "seikyushosaibanKbn", hidden: true },
  { field: "seikyushoNo", hidden: true },
  { field: "kaishuKbn", hidden: true },
  { field: "itakusokoCd", hidden: true },
  { field: "shatenCd", hidden: true },
  { field: "kigyoCd", hidden: true },
  { field: "tenpoCd", hidden: true },
  { field: "tankamarumeKbn", hidden: true },
  { field: "tankahasuichi", hidden: true },
  { field: "kyakusakinoKbn", hidden: true },
  { field: "sakujoyoteiKbn", hidden: true },
];

const focusId = "B000150";

export const B000150 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするRef
  const isDefaultPage = useRef(false);
  // ダイアログの開閉を行う関数
  const handleSubmit = useContext(SDialogContext);
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();

  // 初期表示イベント
  useEffect(() => {
    methods.setValue("calledParam", props.calledParam);

    // 削除予定区分チェック除外区分処理
    if (props.deljogaiKbn) {
      methods.setValue("deljogaiKbn", props.deljogaiKbn);
    }

    // 取引終了日
    if (props.torihikishuryoYmd) {
      methods.setValue("torihikishuryoYmd", props.torihikishuryoYmd);
    }

    // 初回フォーカス先
    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    handleSubmit(data);
  };

  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      setMsg("");

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 得意先コード、得意先支店コードの検索条件の組み合わせ
      // 1.得意先コード(From)のみ入力されている場合
      // そのまま検索できる

      // 2.得意先支店コード(From)のみ入力されている場合
      // 得意先コード(From)の入力を必須とする

      // 得意先支店コード(From)が入力されている場合
      if (fields.tokuishitenCdFrom !== "") {
        // 得意先コード(From)が入力されていない場合
        if (fields.tokuiCdFrom === "") {
          //エラーを出す
          setMsg(getClientError("B000150_001"));
        }
      }

      // 3.得意先コード(To)もしくは得意先支店コード(To)のみ入力されている場合
      // 得意先コード(From)と得意先支店コード(From)、得意先コード(To)と得意先支店コード(To)の入力を必須とする

      // 得意先コード(From)か得意先支店コード(From)が入力されていない場合
      if (fields.tokuiCdFrom === "" || fields.tokuishitenCdFrom === "") {
        // 得意先コード(To)か得意先支店コード(To)が入力されている場合
        if (fields.tokuiCdTo !== "" || fields.tokuishitenCdTo !== "") {
          // エラーを出す
          setMsg(getClientError("B000150_002"));
        }
      }

      // 検索パラメータを作成する。
      const param: B000150FindRequest = {
        tokuiCdFrom: fields.tokuiCdFrom,
        tokuishitenCdFrom: fields.tokuishitenCdFrom,
        tokuiCdTo: fields.tokuiCdTo,
        tokuishitenCdTo: fields.tokuishitenCdTo,
        shokaKbn: fields.shokaKbn?.value,
        name: fields.name,
        torihikisakibun: fields.torihikisakibun?.value,
        tokuibunCd: fields.tokuibunCd,
        calledParam: fields.calledParam,
        deljogaiKbn: fields.deljogaiKbn,
        torihikishuryoYmd: fields.torihikishuryoYmd,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        // ["出力項目名,順番(asc/desc", ...]
        sort: ["tokuiCd,asc"],
      };

      // API呼び出し
      B000150Find(param)
        // 正常取得時
        .then((value) => {
          const offset = query.pageSize * query.page;
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="得意先照会"
        gridTemplateColumns="6rem 7rem 5rem 1rem 7rem 5rem 6rem 9rem"
      >
        <SLabel>得意先コード</SLabel>
        <SNumberField name="tokuiCdFrom" code size={6} {...register(1)} />
        <SNumberField name="tokuishitenCdFrom" code size={4} {...register(2)} />
        <SText>～</SText>
        <SNumberField name="tokuiCdTo" code size={6} {...register(3)} />
        <SNumberField name="tokuishitenCdTo" code size={4} {...register(4)} />
        <SLabel>消化区分</SLabel>
        <SCodeSelect name="shokaKbn" options={B000ShokaKbn} {...register(5)} />
        <SLabel gridColumn="1">得意先名</SLabel>
        <STextField
          name="name"
          size={40}
          gridColumn="span 5"
          {...register(6)}
        />
        <SLabel gridColumn="1">取引先分類</SLabel>
        <SCodeSelect
          name="torihikisakibun"
          options={Torihikisakibun}
          {...register(7)}
          onBlur={() => B000111TokuibunNm(methods, navigate, setMsg)}
        />
        <SNumberField
          name="tokuibunCd"
          code
          size={4}
          {...register(8)}
          dialog={<B000111 meishoKbn={""} />}
          handleSubmit={() => {}}
          onBlur={() => B000111TokuibunNm(methods, navigate, setMsg)}
        />
        <STextField name="tokuibunNm" size={40} disabled gridColumn="span 3" />
        <SNormalButton
          label={labels.buttons.search}
          onClick={handleClickSearchButton}
          gridRow={3}
          gridColumn={8}
          align="right"
          {...register(9)}
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          handleDoubleClick={handleDoubleClickTableRow}
        />
      </SFrame>
    </FormProvider>
  );
};
